import { Injectable, NgZone } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';
import { environment } from '../../../environments/environment';
import { LoggedUser } from '../auth/logged-user';

@Injectable({
  providedIn: 'root',
})
export class DatadogRumService {
  datadogRum = datadogRum;

  isEnabled = environment.datadogRum.enabled;

  constructor(private zone: NgZone) {}

  init(): void {
    if (this.isEnabled) {
      this.zone.runOutsideAngular(() => {
        this.initRum();
      });
    }
  }

  setUserInformation(user: LoggedUser): void {
    if (this.isEnabled) {
      this.datadogRum.setUser({
        email: user.email,
        name: user.name,
      });
    }
  }

  private initRum(): void {
    this.datadogRum.init({
      applicationId: environment.datadogRum.applicationId,
      clientToken: environment.datadogRum.clientToken,
      site: environment.datadogRum.site,
      service: environment.datadogRum.service,
      env: environment.datadogRum.env,
      // Specify a version number to identify the deployed version of your application in Datadog
      // version: '1.0.0',
      sessionSampleRate: environment.datadogRum.sessionSampleRate,
      sessionReplaySampleRate: environment.datadogRum.sessionReplaySampleRate,
      trackUserInteractions: environment.datadogRum.trackUserInteractions,
      trackResources: environment.datadogRum.trackResources,
      trackLongTasks: environment.datadogRum.trackLongTasks,
      defaultPrivacyLevel: 'mask-user-input',
      trackFrustrations: environment.datadogRum.trackFrustrations,
    });

    this.datadogRum.startSessionReplayRecording();
  }
}
